var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopBanner',{attrs:{"partner-id":_vm.partnerId}}),_c('NosCategories',{attrs:{"title":_vm.$t('city.shops'),"partner-id":_vm.partnerId,"is-shop":true}}),_c('Decouvrir',{attrs:{"partner-id":_vm.partnerId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }